import { Injectable, Injector } from '@angular/core';
import { HttpInterceptorService } from '../../core/services/http-interceptor.service';
import { WorkflowConfigService } from './workflow-config.service';
import { HttpClient } from '@angular/common/http';
import { CoreActionCreatorService } from '../../core/services/core-action-creator.service';
import { flatMap } from 'rxjs/operators';
import { Resources } from '../constants/resources.enum';
import { Store } from "@ngrx/store";
import { SessionRefreshService } from "@ispm/core/services/session-refresh.service";
import { IEService } from "@ispm/shared/services/IE.service";
import { CryptoService } from "@ispm/migration/services/crypto.service";
import { Router } from "@angular/router";

@Injectable()
export class ResourceRestService extends HttpInterceptorService {

  constructor(
     protected workflowConfigService: WorkflowConfigService,
     httpClient: HttpClient,
     injector: Injector,
     coreAC: CoreActionCreatorService,
     store: Store<any>,
     sessionRefreshService: SessionRefreshService,
     ieService: IEService,
     cryptoService: CryptoService,
     router: Router
  ) {
    super(httpClient, injector, coreAC , store, sessionRefreshService, ieService, cryptoService, router);
  }

  /**
   * return resources string separated by |,
   * the order if the resources represent the fallbacks order
   *
   * @param {Resources} resourcesNames
   * @returns {string}
   */
  public static getResourcesString(...resourcesNames: Array<Resources>): string {
    return resourcesNames.join('|');
  }

  buildUrl(url, params= { }) {
    return this.workflowConfigService.propertiesPopulate(params).pipe(
      flatMap((_params) => super.buildUrl(url, _params)),
      flatMap(_url => this.workflowConfigService.interpolateWithResourcesMap(_url))
    );
  }

  normalizeBody(body) {
    return this.workflowConfigService.propertiesPopulate(body);
  }




}
